import * as actions from '../actions/myItemsActions';

const initialState = {
  myItems: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_MY_ITEMS:
      /**
       * Faster than state.myItems.toString() === action.payload.toString()
       */
      const update = (
        (state.myItems.length === 0 && action.payload.length === 0) ||
        (state.myItems.length !== action.payload.length) || // Short circuit
        (state.myItems.filter(myItem => {
          // TODO: use BigNumber.isEqualTo()
          return action.payload.filter(item => {
            return (myItem.id === item.id);
          })
        }).length !== action.payload.length)
      );

      return {
        ...state,
        myItems: (update) ? action.payload : state.myItems
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/myItemsReducer.js